import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { HelmetProvider } from 'react-helmet-async';
import { toast } from 'sonner';
import { registerSW } from 'virtual:pwa-register';
import App from './App.tsx';
import './index.css';
import { logger } from './lib/logger';
import { scrubSentryEvent } from './lib/sentryScrub';
import { resolveSentryEnvironment } from './lib/sentryEnvironment';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // F6-12: separa App de Panel Admin y Dev de Producción (ver sentryEnvironment.ts).
  environment: resolveSentryEnvironment('app'),
  enabled: import.meta.env.PROD,
  tracesSampleRate: 0.1,
  // F5-13: depura tokens/contraseñas/secrets antes de enviar cualquier evento a
  // Sentry (tercero externo), aunque hoy este inerte por falta de DSN (R-24).
  beforeSend: scrubSentryEvent,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
});

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

registerSW({
  onNeedRefresh() {
    toast('Nueva versión disponible', {
      description: 'Recarga la página para actualizar Mestly.',
      action: { label: 'Actualizar', onClick: () => window.location.reload() },
      duration: Infinity,
    });
  },
  onOfflineReady() {
    logger.info('Mestly listo para usar sin conexión');
  },
});
